import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useToast } from '../components/shared/Toast.tsx';
import { useTranslation } from '../i18n.ts';
import { useTierAccess } from './useTierAccess.ts';
import { useProjectStore } from '../stores/useProjectStore.ts';
import { useQualityStore, zichtbareMeldingen, meldingTekst } from '../stores/useQualityStore.ts';

/**
 * #1775 — na opslaan in de editor: één waarschuwingstoast als de wijziging voor
 * die persoon een NIEUWE melding oplevert. De editor zet de wacht
 * (`watchPerson`); de store vergelijkt zodra de worker na de debounce van 2,5 s
 * de nieuwe analyse terugstuurt. Bestaande meldingen geven geen toast, en het
 * opslaan zelf wacht hier nooit op.
 */
export function useNewQualityIssueToast(): void {
  const newIssues = useQualityStore((s) => s.newIssues);
  const { toast } = useToast();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const uitgebreid = useTierAccess().hasFeature('advancedDataQuality');

  useEffect(() => {
    if (!newIssues) return;
    useQualityStore.getState().clearNewIssues();
    const settings = useProjectStore.getState().currentProject?.settings;
    const [eerste] = zichtbareMeldingen(newIssues.issues, settings, uitgebreid);
    if (!eerste) return;
    toast(t('dqNewIssueToast', { text: meldingTekst(t, eerste) }), 'warning', {
      action: { label: t('dqViewAction'), onClick: () => navigate('/quality') },
      duration: 8000,
    });
  }, [newIssues, toast, t, navigate, uitgebreid]);
}
